import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

import { SetTitle, SetTags } from './store';

export const NotFoundMetaGuard: CanActivateFn = () => {
  const store = inject(Store);
  const dict = new FromDictionaryPipe();

  const title = dict.transform('error-404-title');
  const suffix = dict.transform('meta-titel-suffix');

  store.dispatch(SetTitle({ title: `${title} ${suffix ? '- ' + suffix : ''}` }));
  store.dispatch(SetTags({ properties: { 'og:title': `${title} ${suffix}` } }));

  return true;
};
